module.exports = __webpack_public_path__ + "static/media/partnership-desktop2.a1ae7b4a.png";